import './index.css';
import { SelectionUtils } from '../utils';
import { make } from '../../../utils';
import { toggleModal } from '../../../modal';
import { IconCurlyBrackets } from '@codexteam/icons';

export default class CustomFieldSelector {

  static get isInline() {
	return true;
  }

  static get sanitize() {
	return {
	  span: {
		id: true,
		contenteditable: true,
		class: true
	  }
	};
  }

  static get shortcut() {
	return 'CMD+ALT+V';
  }
  
  get tag() {
	return 'span';
  }

  constructor({ config, api }) {
	this.api = api;
	this.config = config;
	this.selection = new SelectionUtils();
	this.button = null;
	this.modal = document.querySelector('#customFieldsSelection-modal');
  }

  render() {
	this.button = document.createElement('button');
	this.button.type = 'button';
	this.button.classList.add(this.api.styles.inlineToolButton);
	this.button.innerHTML = IconCurlyBrackets;

	return this.button;
  }

  surround(range) {

	customFieldName = range.toString()
	  .replaceAll('{', '')
	  .replaceAll('}', '');

	const fetchCustomField = (e) => {
	  if (e.detail.status !== 'SELECTED') {
		console.log('Selezione Cancellata');
		this.selection.restore();
		return;
	  }

	  fetch(`/Templates/CustomFields/Ajax/?handler=CustomFieldById&id=${e.detail.customFieldId}`)
		.then(response => {
		  if (!response.ok)
			throw new Error(response);
		  return response.json()
		}).then(json => {
		  this.selection.restore();

		  let range = window.getSelection().getRangeAt(0);
		  let customField = make(this.tag, 'customfield', {
			id: `cf-${json.id}`,
			contenteditable: false,
			innerHTML: `{{${json.name}}}`,
		  });
		  
		  range.deleteContents();
		  range.insertNode(customField);

		  this.selection.collapseToEnd();
		})
	};

	this.selection.save();

	document.addEventListener('customfieldselected', fetchCustomField,
	  { once: true });

	toggleModal(this.modal);	
  }

  checkState(selection) {}
    
}